export default __webpack_public_path__ + "static/media/640_business04-it-web.2b3c236a.png";